import { CardHorizontalDivider, Flex, Grid } from "@eworkit/iris";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { EditableSection } from "@/components/EditableSection";
import { Header } from "@/components/Header";
import { Section } from "@/components/Section";
import { UserContext } from "@/components/User";
import { CompanyBankingSection } from "@/views/Settings/CompanySettings/BankingDetails/CompanyBankingSection";

export const CompanyBankingSettings = () => {
  const { t } = useTranslation("session");

  const User = useContext(UserContext);

  const isAdmin = User.hasCompanyAdminPrivileges();

  return (
    <Section padding={["lg"]} borderRadius>
      <Header size="sm" weight="bold" text={t("USERS.SETTINGS.BANKING_DETAILS.FORM.HEADER")} />

      <CardHorizontalDivider />

      <Flex flexDirection="column" gap="sm">
        <Grid gap="sm">
          <EditableSection editable={isAdmin}>
            {editableProps => <CompanyBankingSection editableProps={editableProps} />}
          </EditableSection>
        </Grid>
      </Flex>
    </Section>
  );
};
